import { Component, Input } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';

import { FlexModule } from '@angular/flex-layout';
import { ICapnographyDetailed } from 'src/app/interfaces/Capnography/ICapnographyDetailed';
@Component({
  selector: 'app-capnography-expand',
  standalone: true,
  templateUrl: './capnography-expand.component.html',
  styleUrls: ['./capnography-expand.component.css'],
  imports: [NzLayoutModule, NzTableModule, TranslateModule, FlexModule],
})
export class CapnographyExpandComponent {
  @Input() item: ICapnographyDetailed = {};
}
